import {MediaType} from '@sim/media/models/media';

export async function getBase64SrcFromBlob(blob: any) { // FIXME: Improve typing to accept only Blob
  return new Promise<string>(async (resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = async () => {
      resolve(reader.result as string);
    };
  });
}

export function extractFiles(fileList: FileList) {
  const files: File[] = [];
  for (let i = 0; i < fileList.length; i++) {
    const file = fileList.item(i);
    if (file) {
      files.push(file);
    }
  }
  return files;
}

export function extractMediaTypeFromPath(path: string): MediaType {
  const startExtensionIndex = path.lastIndexOf('.');
  const imageExtension = path.substr(startExtensionIndex + 1);
  switch (imageExtension) {
    case 'png':
    case 'jpeg':
    case 'jpg':
      return `image/${imageExtension}` as MediaType;
    case 'pdf':
      return `application/pdf`;
    default:
      return 'image/*';
  }
}

export function extractMediaNameFromPath(path: string) {
  const startNameIndex = path.lastIndexOf('/');
  const startExtensionIndex = path.lastIndexOf('.');
  const imageName = path.substring(startNameIndex + 1, startExtensionIndex);
  return imageName;
}

export async function extractFileUrl(file: Blob) {
  try {
    const url = await getBase64SrcFromBlob(file);
    return url;
  } catch (e) {
    return undefined;
  }
}


export type MediaDeleteErrorInfo = Record<string, { id: string, code: string }[]>;
const parseSourceEntityNameString = (s: string): string => s.split('\\').pop() || '';
const parseEntityIdString = (s: string): string => s.split('(')[0].trim();
/**
 * Backend marker for delete constraint errors.
 * Do not localize; this must match the exact token returned by the backend.
 */
export const DELETE_CONSTRAINT_MARKER = 'riferito dai seguenti beni/documenti:';
export const getErroredIdsMap = (errString: string): MediaDeleteErrorInfo => {
  const erroredIdsMap: MediaDeleteErrorInfo = {};
  const tmp = errString.split(DELETE_CONSTRAINT_MARKER).pop() || '';
  tmp.split(';').forEach(beneRefString => {
    const splitted = beneRefString.split(':');
    if (splitted.length !== 2) return;
    const beneType = parseSourceEntityNameString(splitted[0]);
    const objList: { id: string, code: string }[] =
      splitted[1].split(',').map(entityIdString => {
        const pair = entityIdString.split('(');
        const id = pair[0].trim();
        const code = pair[1].replace(')', '').trim();
        return {id, code};
      })
    erroredIdsMap[beneType] = objList;
  })
  return erroredIdsMap;
}
/*
* Impossibile eliminare il file 63f729d33fd3b5719a069546 (path: 'master/AM006AG00coup.jpg') perché è riferito dai seguenti beni/documenti:
*  App\\Domain\\Model\\BeneOA: 5e18bf36277548020459dbb5 (AM006AG00COJU),626fa50fa5d5cd4a1f75b2e5 (AM006BR00COJU); App\\Domain\\Model\\BeneS: 63f729d33fd3b5719a069546 (0094-inc);
* */

export const IObjectTypeToUriPath: Record<string, string> = {
  'BeneOA': 'cards/oa/manager',
  'BeneS': 'cards/s/manager',
  'BeneMI': 'cards/mi/manager',
  'BeneD': 'cards/d/manager',
  'BeneF': 'cards/f/manager',
};
